module.exports = __webpack_public_path__ + "img/homes_step1.18659814.svg";